<template >
    <div v-if="this.surveyId"  class="questionario-container">
        

  <div class="col-xs-3 col-xs-offset-5">
      <div id="loadbar" style="display: none;">
        <div class="blockG" id="rotateG_01"></div>
        <div class="blockG" id="rotateG_02"></div>
        <div class="blockG" id="rotateG_03"></div>
        <div class="blockG" id="rotateG_04"></div>
        <div class="blockG" id="rotateG_05"></div>
        <div class="blockG" id="rotateG_06"></div>
        <div class="blockG" id="rotateG_07"></div>
        <div class="blockG" id="rotateG_08"></div>
    </div>
  </div>
  <div class="row">
  
    <div class="col-12" align="center">
        <h2 class="domanda-questionario">
    <span class="label label-success" id="qid">{{ this.question }}</span>  
  </h2>
    <hr />
    <div class="quiz" id="quiz" data-toggle="buttons">
        <form id="survey" method="post">
            <template  v-for="(answer, index) in answers" :key="answer.id">
                <risposta
                    :className="this.getRispostaClassName(index)"
                    :answerData="answer"
                    :text="answer.text"
                    :rispostaId="answer.rispostaId"
                    :onClickCallback="answer.onClickCallback || this.getNextQuestionByAnswer"
                />
            </template>
        </form>
    </div>
    <div class="row">
            
            <div class="col-md-6">
                <a href="/"><button v-if="paginaLoader !== true && paginaRingraziamentoAperta"    class="torna-home float-start btn btn-lg pull-left col-xs-12 col-lg-5" >{{intl[$store.state.lang]["torna-home"]}}</button></a>
                <button v-if="this.answerHistory.length > 0 && paginaLoader !== true && !paginaRingraziamentoAperta"  :onclick="this.indietroClick"  class="domanda-precedente float-start btn btn-lg pull-left col-xs-12 col-lg-5" ><span class="bi-chevron-left"></span>{{intl[$store.state.lang]["go-back"]}}</button>
            </div>
            <div class="col-md-6">
                <button :onclick="this.restartQuiz" class="nuovo-questionario float-end btn btn-danger btn-lg pull-right col-lg-6 col-xs-12" ><span class="bi-arrow-clockwise"></span>{{intl[$store.state.lang]["new-quiz"]}}</button>
            </div>
     
    </div>
    </div>
   
  </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import Risposta from "../risposta/Risposta.vue"
import {apiUrls} from "../../api/apiUrls"
import {formatDate} from "../../api/apiUtils"
import questionarioStore from "./store/index"
import { mapState } from 'vuex'
export default {
    name: "questionario",
     components: {
            "risposta": Risposta,

        },
    props: {
        paginaRingraziamentoAperta: {
            type: Boolean,
            default: false
        },
        paginaLoader: {
            type: Boolean,
            default: null,
        },
        surveyId: {
            type: Number,
            default: null,
        },
        saveAnswerHistoryMode:{
            type: Boolean,
            default: process.env.VUE_APP_RICORDA_RISPOSTE_QUESTIONARIO === "true"
        },
        
        rispostaTerminaleCallback:{
            type: Function,
            default: (response,answerInfo) => {console.log("Risposta terminale: ",answerInfo)}
        },
        rispostaCallback:{
            type: Function,
            default: (answerInfo) => {console.log("Risposta non terminale: ",answerInfo)}
        },
        onIndietroClickCallback:{
            type: Function,
            default: () => {console.log("Click su indietro")}
        },
        onRicominciaQuestionarioClickCallback:{
            type: Function,
            default: () => {console.log("Click su ricomincia questionario"); }
        },
        rispostaFinaleCallback:{
            type: Function,
            default: (type) => {console.log("Risposta finale: ")}
        },
        setPaginaLoaderCallback:{
            type: Function,
            default: (value) => {console.log("Pagina loader callback : ", value)}
        },
        onCreateSurveyLogCallback:{
            type: Function,
            default: (response) => {console.log("Create survey log callback: ",response)}
        },
        
    },
   
    created() {
        let mustCreateNewSurveyLog = !localStorage.getItem("survey_log_id_not_ended")
        
        if(this.surveyId && !this.saveAnswerHistoryMode){
            
            this.createSurveyLogAndShowInitialQuestion()
        }
        else {
            if(this.saveAnswerHistoryMode){
                if(this.surveyId && mustCreateNewSurveyLog){
                    this.createSurveyLogAndShowInitialQuestion()
                }else{
                    this.startFromExistingSurveyLog()
                }
            }
            
        }
        
        
    },
    beforeMount(){
        this.$store.registerModule("questionarioStore-"+this.surveyId, questionarioStore)
    },
    

    data: function () {
        return {
            intl: intl,
            answers: [],
            question: "",
            questionId: null,
            answerHistory: [],
            quizLoader: false,
            lastSurveyLogId: null
        };
    },
    methods: {
        startFromExistingSurveyLog(){
            let surveyLogId = localStorage.getItem("survey_log_id_not_ended")
            let getQuestionLogDetailPromise = axios.get(apiUrls["survey_log_detail"] + surveyLogId)
            let answerHistory = []
            this.quizLoader = true
            getQuestionLogDetailPromise
                        .then((response) => {
                            if(response.data && response.data.survey_log_question_done){
                                if(response.data.survey_log_question_done.length > 0){
                                    
                                    response.data.survey_log_question_done.map((logDone,index) => {
                                       
                                        answerHistory.push({answerId :logDone.answer_id,logDoneId:logDone.id})
                                        this.lastSurveyLogId = logDone["survey_log_id"]
                                    })
                                    this.answerHistory = answerHistory
                                    this.getNextQuestionByAnswer({id: this.answerHistory[this.answerHistory.length - 1].answerId},false)
                                }else{
                                
                                //caso in cui si è tornati alla prima pagina non essendoci risposte nel log_done
                                this.lastSurveyLogId = surveyLogId
                                this.getNextQuestionByAnswer({id: 0},false)
                                }
                            }else{
                                this.quizLoader = false
                            }
                             
                        })
                        .catch((error) => {
                            this.quizLoader = false
                        }); 
            
        },
        createSurveyLogAndShowInitialQuestion(){
            let getStartingQuestionPromise = axios.get(
                apiUrls["user_survey"]+this.surveyId+"/0")
            let createSurveylogPromise = axios.post(apiUrls["create_survey_log"],{
                "survey_id": this.surveyId,
                "finished": 0,
                "started": formatDate(new Date())
            })
            this.quizLoader = true
            this.question = ""
             getStartingQuestionPromise
                .then((response) => {
                    if(response.data && response.data.answer){
                        this.answers = response.data.answer
                    }
                    if(response.data && response.data.text){
                        this.question = response.data.text
                        this.questionId = response.data.id
                    }
                    createSurveylogPromise
                        .then((response) => {
                            if(response.data && response.data.id){
                                this.lastSurveyLogId = response.data.id
                                this.saveAnswerHistoryMode && localStorage.setItem("survey_log_id_not_ended", response.data.id);
                            }
                            this.quizLoader = false
                            this.onCreateSurveyLogCallback(response)
                        })
                        .catch((error) => {
                            this.quizLoader = false
                        }); 
                    
                })
                .catch((error) => {
                    this.quizLoader = false
                }); 

        },
        restartQuiz(){
            
            var answer = window.confirm("Le risposte fornite nel questionario attuale andranno perse");
            
            if (answer && localStorage.getItem("survey_log_id_not_ended")) {
                
               this.quizLoader = true
                axios.put(apiUrls["edit_survey_log"] + this.lastSurveyLogId, {finished: 1})
                        .then((response) => {
                            this.answerHistory = []
                            this.lastSurveyLogId = null
                            this.questionId = null
                            this.saveAnswerHistoryMode && localStorage.removeItem("survey_log_id_not_ended")
                            this.createSurveyLogAndShowInitialQuestion()
                            this.onRicominciaQuestionarioClickCallback()
                        })
                        .catch((error) => {
                         this.quizLoader = false
                         this.onRicominciaQuestionarioClickCallback()
                        });
                    
            }
            else {
                this.createSurveyLogAndShowInitialQuestion()
                this.onRicominciaQuestionarioClickCallback()
            }
           
                
        },
        closeSurveyLog (createNewSurveyLog) {
                 
                 axios.put(apiUrls["edit_survey_log"] + this.lastSurveyLogId, {finished: 1})
                        .then((response) => {
                            this.answerHistory = []
                            this.lastSurveyLogId = null
                            this.questionId = null
                            this.saveAnswerHistoryMode && localStorage.removeItem("survey_log_id_not_ended")
                            createNewSurveyLog ?  this.createSurveyLogAndShowInitialQuestion() : this.quizLoader = false
                            
                          
                        })
                        .catch((error) => {
                            this.quizLoader = false
                        });
        },
        getRispostaClassName(index) {
            index++;
            return "element-animation"+index+" btn btn-lg btn-block";
        },
     
        indietroClick() {
            this.onIndietroClickCallback()
            this.getPrevQuestionByAnswer()
        },

        getPrevQuestionByAnswer() {
            
            if(this.answerHistory.length > 0){
                this.quizLoader = true
                let answerId = 0
                
                if(this.answerHistory.length > 1){
                    answerId = this.answerHistory[this.answerHistory.length -2].answerId
                }
                

                axios
                    .get("user_survey/"+this.surveyId + "/" + answerId)
                        .then((response) => {
                            if(response.data && response.data.answer){
                                this.answers = response.data.answer
                            }
                            if(response.data && response.data.text){
                                this.question = response.data.text
                                this.questionId = response.data.id
                            }
                            if(this.answerHistory.length >0){
                                if(this.answerHistory[this.answerHistory.length -1 ].answerId === "fake-answer"){
                                    
                                    this.answerHistory.pop()
                                    if(Object.keys(response.data).length === 0){
                                        this.rispostaTerminaleCallback(response,{id: answerId})
                                    }
                                    this.quizLoader = false
                                }else{
                                    axios.delete(apiUrls["delete_survey_log_question_done"]+this.answerHistory[this.answerHistory.length -1 ].logDoneId)
                                    .then((response) => {
                                            this.rispostaCallback(response,{id: answerId})
                                            this.answerHistory.pop()
                                            this.quizLoader = false
                                    })
                                    .catch((error) => {
                                        this.quizLoader = false
                                    });
                                }


                                
                            } 
                        })
                        .catch((error) => {
                            
                            this.quizLoader = false
                        });
            }
            
            
        },

        getNextQuestionByAnswer(answerData,saveLogDone) {
            this.quizLoader = true
            let questionId = this.questionId
            let getNextQuestion = () => {
                axios
                .get("user_survey/"+this.surveyId + "/" + answerData.id)
                    .then((response) => {
                        
                        if(Object.keys(response.data).length === 0){
                            
                            this.rispostaTerminaleCallback(response,answerData)
                            let lastQuestionAndAnswer = this.getLastQuestionAndAnswer()
                            this.question = lastQuestionAndAnswer.question
                            this.answers = lastQuestionAndAnswer.answers
                        }else{
                            if(response.data && response.data.answer){
                                this.answers = response.data.answer
                            }
                            if(response.data && response.data.text){
                                this.question = response.data.text
                                this.questionId = response.data.id
                            }
                            this.rispostaCallback(response,answerData)
                        }

                        this.quizLoader = false  
                    })
                    .catch((error) => {
                        this.rispostaCallback(error,answerData)
                        this.quizLoader = false
                    });
            }

            if(saveLogDone){
                            axios.post(apiUrls["create_survey_log_question_done"],{
                                "survey_log_id": this.lastSurveyLogId,
                                "question_id": questionId,
                                "answer_id": answerData.id
                            })
                                .then((response) => {
                                    this.answerHistory.push({answerId : answerData.id, logDoneId: response.data.id})
                                    getNextQuestion()
                                })
                                .catch((error) => {
                                   
                                });
                        } else{
                           getNextQuestion()
                        }     
                 
        },

        getLastQuestionAndAnswer() {
            switch(process.env.VUE_APP_QUESTIONARIO_ID){
                case "massei":
                    return {
                        question: "Vuoi prenotare subito un appuntamento o preferisci essere ricontattato per avere maggiori informazioni?",
                        answers: [
                            {
                                rispostaId: "appointment",
                                onClickCallback:() =>{
                                    this.answerHistory.push({answerId: "fake-answer"})
                                    this.rispostaFinaleCallback("massei-voglio-prenotare-appuntamento")
                                }
                            },
                            {
                                rispostaId: "contact",
                                onClickCallback:() => {
                                    this.answerHistory.push({answerId: "fake-answer"})
                                    this.rispostaFinaleCallback("massei-voglio-essere-contattato")
                                    }
                            }]
                    }
                default:
                    return {
                        question: "Hai trovato quello che cercavi?",
                        answers: [{rispostaId: "yes",onClickCallback:this.closeSurveyLog},{rispostaId: "no",disableClick:true}]
                    }
            }
        }

    },
    watch: {
        
        quizLoader : {
                handler : function(newValue, oldValue) {
                  
                    if(oldValue !== newValue){
                 
                        this.setPaginaLoaderCallback({quizLoader: newValue})
                    }                
                },
                deep : true
        },
        resetQuiz : {
                handler : function(newValue, oldValue) {
                    if(oldValue !== newValue && newValue === true){
                        this.closeSurveyLog(true)
                        this.$store.commit("questionarioStore-"+this.surveyId+"/doNotResetQuiz")
                    }                
                },
                deep : true
        },
        closeQuiz : {
                handler : function(newValue, oldValue) {
                    if(oldValue !== newValue && newValue === true){
                        this.closeSurveyLog()
                        this.$store.commit("questionarioStore-"+this.surveyId+"/doNotCloseQuiz")
                    }                
                },
                deep : true
        }
        
    },
    computed: {
        ...mapState({
       
        resetQuiz(state) {
            
            if(state["questionarioStore-"+this.surveyId]) return state["questionarioStore-"+this.surveyId].resetQuiz
            //return this.$store.state["questionarioStore-"+this.surveyId].resetQuiz 
        },
        closeQuiz(state) {
            
            if(state["questionarioStore-"+this.surveyId]) return state["questionarioStore-"+this.surveyId].closeQuiz
            //return this.$store.state["questionarioStore-"+this.surveyId].resetQuiz 
        },
    }),
        imageRoot(){
            return process.env.VUE_APP_BASE_PATH
        },
        
    },
    unmounted(){
        this.$store.unregisterModule("questionarioStore-"+this.surveyId)
    }
};
</script>
